import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { CUSTOM_VEHICLE_TRIM_ID } from '../../common/constants';

export const GET_TRIMS = gql`
  query GetVehicleTrims($modelId: Int!, $year: Int!) {
    vehicleTrims(modelId: $modelId, year: $year) {
      trimId
      trimName
    }
  }
`;

export default function useVehicleTrims(modelId, year) {
  return useQuery(GET_TRIMS, {
    skip: !modelId || !year,
    variables: {
      modelId,
      year,
    },
  });
}

export const useVehicleTrimOptions = (trims, activeTrims) => useMemo(
  () => {
    const options = (trims || []).map(({ trimId, trimName }) => ({
      label: trimName,
      value: trimId,
    }));

    if (activeTrims && !options.find(m => m.label === activeTrims)) {
      options.push({ label: activeTrims, value: CUSTOM_VEHICLE_TRIM_ID });
    }

    return options;
  },
  [trims, activeTrims],
);
